import type { ComponentProps } from 'react';
import React from 'react';
import { Box, Flex, Text } from '@skin-seoul/design-system';
import ProductImage from '../components/ProductImage';
import { Condition } from '../../../utils/react/Condition';
import { useProductCard } from '../ProductCardContext';
import { isNil } from 'es-toolkit';
type ProductCardImageProps = {
  topSlot?: React.ReactNode;
  bottomSlot?: React.ReactNode;
} & ComponentProps<typeof Box>;
export const VerticalProductCardImage = ({
  topSlot,
  bottomSlot,
  ...props
}: ProductCardImageProps) => {
  const {
    ranking
  } = useProductCard();
  return <Box borderRadius="8px" background="neutral.50" overflow="hidden" height={{
    base: '200px',
    tablet: '300px'
  }} maxHeight={{
    base: '200px',
    tablet: '300px'
  }} boxSizing="border-box" padding={{
    base: '38px 12px 28px 12px',
    tablet: '36px 12px 30px 12px'
  }} position="relative" width="100%" minWidth={0} {...props} data-sentry-element="Box" data-sentry-component="VerticalProductCardImage" data-sentry-source-file="VerticalProductCardImage.tsx">
      <Flex position="absolute" zIndex={2} top={0} left={0} width="100%" data-sentry-element="Flex" data-sentry-source-file="VerticalProductCardImage.tsx">
        <>{topSlot}</>
      </Flex>
      <ProductImage data-sentry-element="ProductImage" data-sentry-source-file="VerticalProductCardImage.tsx" />
      <Condition expression={!isNil(ranking)} then={<Flex position="absolute" bottom={0} left={0} pb="3px" h={12} w={12} alignItems="center" justifyContent="center">
            <Text color="neutral.200" textStyle="heading.h2">
              {ranking}
            </Text>
          </Flex>} data-sentry-element="Condition" data-sentry-source-file="VerticalProductCardImage.tsx" />
      <Flex position="absolute" bottom={0} zIndex={2} left={0} width="100%" data-sentry-element="Flex" data-sentry-source-file="VerticalProductCardImage.tsx">
        <>{bottomSlot}</>
      </Flex>
    </Box>;
};